import angular from 'angular';

import Component from './mc-classic.component';

const ClassicModule = angular.module('control-room.mc-classic', []).component('crMcClassic', Component);

export default ClassicModule;
